<div >
  <mat-icon *ngIf="EnableNotifyLog" [ngClass]="alert" class="notify-log-icon" [title]="tip" (click)="open()" >
    {{icon}}
  </mat-icon>
  <div *ngIf="showLog" class="log-panel mwt_border main_border">
    <ng-container *ngFor="let msg of msgLog;let i = index">
      <div class="message-log" [ngStyle]="msg.style"
          #snackdiv>
          <div [ngClass]="msg.cssClass" class="msg-type"></div>
          <div style="flex-grow: 1;">{{msg.content}}</div>
          <mat-icon (click)="read(i)"> clear</mat-icon>
      </div>
    </ng-container>
  </div>
</div>

